<template>
  <section class="section">
    <div class="container">
      <SectionHead eyebrow="VALUE PROPOSITION">
        痛点 · <span style="color:#83e6ff">解法对照</span>
      </SectionHead>
      <div class="ps-map">
        <div v-for="(p, i) in pains" :key="i" class="ps-row reveal">
          <div class="ps-pain">
            <div class="ps-pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            </div>
            <div class="ps-pain-text">
              <div class="ps-pain-title">{{ p[0] }}</div>
              <div class="ps-pain-desc">{{ p[1] }}</div>
            </div>
          </div>
          <div class="ps-arrow">→</div>
          <div class="ps-solution">
            <div class="ps-solution-text">
              <div class="ps-solution-title">{{ solutions[i][0] }}</div>
              <div class="ps-solution-desc">{{ solutions[i][1] }}</div>
            </div>
            <div class="ps-check">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
          </div>
        </div>
        <div class="ps-caption">
          <div class="ps-caption-title">四把枷锁，<span style="color:#83e6ff">一把一把解开</span></div>
          <div class="ps-caption-sub">过去的你单打独斗，现在的你拥有整个生态。</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHead from '@/components/display/SectionHead.vue';

const PAINS = [
  ['用人成本高', '闲时养不起，忙时不够用'],
  ['供应商资源弱', '量小没议价权，资金链紧绷'],
  ['核心竞争力少', '没技术没产品，只能卷价格'],
  ['无品牌资质', '没一级资质，投不进大项目']
];

const SOLUTIONS = [
  ['弹性用工', '按需调用，160次服务仅14.3万，不用养人也能干活'],
  ['集采通道', '2000+合伙人集采压价，帮你把成本打下来'],
  ['方案库+渠道网', '你的短板由生态补齐，你的长板被放大变现'],
  ['资质共享', '一级资质直接使用，让你投得进大项目']
];

export default {
  name: 'HomeValueProposition',
  components: { SectionHead },
  data() {
    return {
      pains: PAINS,
      solutions: SOLUTIONS
    };
  }
};
</script>

<style lang="less" scoped>
.ps-map {
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-width: 1080px;
  margin: 0 auto;
}

.ps-row {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 18px 28px;
  border: 1px solid var(--line);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02));
  border-radius: 18px;
  position: relative;
  overflow: hidden;
  transition: transform 0.35s, border-color 0.35s, box-shadow 0.35s, background 0.5s ease;

  &:hover {
    transform: translateX(14px) !important;
    border-color: rgba(131, 230, 255, 0.6);
    box-shadow: 0 22px 48px rgba(0, 0, 0, 0.4), inset 4px 0 24px -8px rgba(92, 242, 168, 0.45), inset -4px 0 24px -8px rgba(181, 140, 255, 0.35);
    background: linear-gradient(90deg, rgba(92, 242, 168, 0.1) 0%, rgba(131, 230, 255, 0.08) 60%, transparent 100%);
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 6px;
    bottom: 6px;
    width: 4px;
    background: linear-gradient(180deg, #5cf2a8 0%, #83e6ff 50%, #b58cff 100%);
    border-radius: 0 4px 4px 0;
    transform: scaleY(0);
    transform-origin: center;
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.5s ease;
    z-index: 2;
    box-shadow: 0 0 0 rgba(92, 242, 168, 0);
  }

  &:hover::after {
    transform: scaleY(1);
    box-shadow: 0 0 20px rgba(92, 242, 168, 0.85), 0 0 40px rgba(131, 230, 255, 0.6);
  }
}

.ps-pain,
.ps-solution {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1;
  min-width: 0;
}

.ps-pain {
  justify-content: flex-start;
}

.ps-pain-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, rgba(255, 120, 131, 0.16), rgba(255, 120, 131, 0.04));
  border: 1px solid rgba(255, 120, 131, 0.3);
  color: #ff7883;
  transition: all 0.3s;

  svg {
    width: 20px;
    height: 20px;
  }
}

.ps-pain-title {
  color: #dde7f5;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
}

.ps-pain-desc {
  color: #8a96ad;
  font-size: 13.5px;
  font-weight: 400;
  line-height: 1.55;
}

.ps-arrow {
  color: #83e6ff;
  font-size: 24px;
  flex-shrink: 0;
  font-weight: 300;
  opacity: 0.85;
  position: relative;
  display: inline-block;
  animation: psArrowPulse 2.2s ease-in-out infinite;
}

.ps-solution {
  justify-content: flex-end;
  text-align: right;
}

.ps-solution-title {
  color: #5cf2a8;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
}

.ps-solution-desc {
  color: rgba(92, 242, 168, 0.75);
  font-size: 13.5px;
  font-weight: 400;
  line-height: 1.55;
}

.ps-check {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, rgba(92, 242, 168, 0.18), rgba(92, 242, 168, 0.04));
  border: 1px solid rgba(92, 242, 168, 0.35);
  color: #5cf2a8;
  transition: all 0.3s;

  svg {
    width: 16px;
    height: 16px;
  }
}

.ps-caption {
  text-align: center;
  margin: 40px auto 0;
}

.ps-caption-title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.04em;
  margin: 0 0 10px;
}

.ps-caption-sub {
  font-size: 14px;
  color: var(--muted);
  line-height: 1.6;
}

@keyframes psArrowPulse {
  0%, 100% { transform: translateX(0); opacity: 0.85; }
  50% { transform: translateX(5px); opacity: 1; }
}

@media (max-width: 720px) {
  .ps-row {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
    padding: 18px;
  }
  .ps-arrow {
    transform: rotate(90deg);
    align-self: center;
    animation: none;
  }
  .ps-solution {
    justify-content: flex-start;
    text-align: left;
  }
}
</style>
